<template>
  <div class="landing">
    <div class="bannerWrapper" v-if="bannerData && bannerData.mediaPath" v-bind:style="{ 'background-image': 'url(' + bannerData.mediaPath + ')' }" />
    <div class="productsWrapper">
      <div class="container">
        <div class="slots">
          <div
            class="slot"
            v-for="(slot, index) in data"
            v-bind:key="index">
            <div class="countdown">
              <div class="countdownInner">
                <div class="title" v-if="slot">Süper İndirimin Bitmesine</div>
                <countDown :isPreview="isPreview" :expectedNow="expectedNow" :endHourDate="slot.endHour" :serverTime="serverTimeFormat"></countDown>
              </div>
            </div>
            <div
              :class="['productList', 'productSize', getBoxSize(slot.numberOfGridColumns)]">
              <div
                v-for="(campaign, index) in slot.campains"
                v-bind:key="index"
                :class="['product', getColumnSize(slot.numberOfGridColumns), 'col-xs-12']"
                v-on:click="handleOnClick(campaign, slot, index)"
                :data-hbus="handleViewEventData(campaign, slot, index)">
                <landingProductSummaryBox
                  :data="campaign"
                  :box-size="getBoxSize(slot.numberOfGridColumns)"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import countDown from "../../components/countDown/countDown";
import landingProductSummaryBox from "../../view/productSummaryBoxes/landingProductSummaryBox/landingProductSummaryBox";

import { BOX_SIZES } from "../../view/productSummaryBoxes/landingProductSummaryBox/landingProductSummaryBoxConstants";
import { SLOT_NAMES } from '../../analytics/davinci/constants';

export default {
  name: "Landing",
  props: {
    data: Array,
    bannerData: Object,
    serverTime: String,
    onClick: Function,
    viewEventData: Function
  },
  components: {
    countDown,
    landingProductSummaryBox
  },
  data() {
    return {
      BOX_SIZES,
      isPreview: this.$parent.isPreview,
      bannerConstants: this.$parent.bannerConstants,
      expectedNow: this.$parent.expectedNow ? moment(this.$parent.expectedNow).format() : undefined,
      slotName: SLOT_NAMES.LIVE_CAMPAIGN_SLOTS
    };
  },
  computed: {
    serverTimeFormat (){
      return this.serverTime
    },
    day() {
      return this.isPreview ? moment(this.expectedNow).format('D') : moment(new Date()).format("DD");
    },
    month() {
      return this.isPreview ? moment(this.expectedNow).format('MMM') : moment(new Date()).format("MMMM");
    },
    dayName() {
      return this.isPreview ? moment(this.expectedNow).format('Y') : moment(new Date()).format("dddd");
    }
  },
  methods:{
    getBoxSize: function(length){
      return length >= 4 ? BOX_SIZES.SMALL : length >= 3 ? BOX_SIZES.MEDIUM : BOX_SIZES.LARGE;
    },
    getColumnSize: function (length) {
      return length >= 4 ? 'col-3' : length >= 3 ? 'col-4' : 'col-6'
    },
    handleOnClick: function (item, slot, index) {
      this.onClick(item, slot, this.slotName, index)
    },
    handleViewEventData: function (item, slot, index) {
      return this.viewEventData(item, slot, this.slotName, index)
    }
  }
};
</script>

<style src="./Landing.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/partials/Landing/Landing.vue